const DynamicName = process.env.VUE_APP_COMPANY_NAME;
const Taco_Cabana = {
    'SITE_NAME': 'Taco Cabana',
    'SITE_URL': process.env.VUE_APP_SITE_URL || 'http://localhost:8080/',
    'LOGO': 'taco-cabana.png',
    'INFO_EMAIL': 'taco-cabana@train321.com',
    'SUPPORT_EMAIL': 'training@tacocabana.com'
}
 const NTG = {
    'SITE_NAME': 'Nick The Greek',
    'SITE_URL': process.env.VUE_APP_SITE_URL || 'http://localhost:8080/',
    'LOGO': 'ntg-logo.png',
    'INFO_EMAIL': 'ntg@train321.com',
    'SUPPORT_EMAIL': 'training@ntg.com'
}

let Dynamic = {};
switch (DynamicName) { 
    case "Taco_Cabana":
        Dynamic[DynamicName] = Taco_Cabana;
        break;
    case "NTG":
        Dynamic[DynamicName] = NTG;
        break;  
    default:
       Dynamic["Taco_Cabana"] = Taco_Cabana;  
}
let DName = Dynamic[DynamicName];
export { DName as Dynamic }